import { useQuery } from 'react-query';
import axios from 'axios';
import { END_POINT } from 'config/environment';

interface AvailablePermissions {
  [group: string]: {
    [permission: string]: string;
  };
}

interface TeamMemberPermissions {
  userId: string;
  userName: string;
  userEmail: string;
  userPermissions: string[];
  availablePermissions: AvailablePermissions;
}

const fetchTeamMemberPermissions = async (
  userId: string, 
  token: string
): Promise<TeamMemberPermissions> => {
  const url = `${END_POINT.BASE_URL}/v1/team/member/${userId}/permissions`;
  const config = {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  
  const response = await axios.get(url, config);
  return response.data;
};

const fetchAvailablePermissions = async (
  token: string
): Promise<AvailablePermissions> => {
  const url = `${END_POINT.BASE_URL}/v1/team/available-permissions`;
  const config = {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  
  const response = await axios.get(url, config);
  return response.data;
};

export const useTeamPermissions = (userId: string, token: string) => {
  return useQuery(
    ['teamPermissions', userId],
    async () => {
      const [memberPermissions, availablePermissions] = await Promise.all([
        fetchTeamMemberPermissions(userId, token),
        fetchAvailablePermissions(token),
      ]);
      
      return {
        ...memberPermissions,
        availablePermissions,
      };
    },
    {
      enabled: !!userId && !!token,
      onError: (error: any) => {
        console.error('Error fetching team permissions:', error);
      },
      onSuccess: (data) => {
        
      },
    }
  );
};

export const useUpdateTeamPermissions = () => {
  const updatePermissions = async (
    userId: string,
    permissions: string[],
    token: string
  ) => {
    const url = `${END_POINT.BASE_URL}/v1/team/member/${userId}/permissions`;
    const config = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(
      url, 
      { permissions },
      config
    );
    
    return response.data;
  };

  return { updatePermissions };
};